import { ShieldCheck } from "lucide-react";

export default function TrustCard() {
    return (
        <section
            data-testid="trust-section"
            className="mx-auto w-full max-w-3xl px-4 pb-10 md:px-6 md:pb-14"
        >
            <div
                data-testid="trust-card"
                className="flex items-center justify-center gap-3 rounded-2xl border border-[#D4AF37]/40 bg-[#0C0C0C] px-5 py-4"
            >
                <ShieldCheck
                    className="h-5 w-5 shrink-0 text-[#D4AF37]"
                    strokeWidth={1.8}
                    aria-hidden="true"
                />
                <p
                    data-testid="trust-card-text"
                    className="text-center text-sm font-semibold leading-snug text-[#FFFFF0] md:text-base"
                >
                    Genuine Work • Clear Guidelines • Regular Payment Cycle
                </p>
            </div>
        </section>
    );
}
